import { render } from "./goodsList.vue?vue&type=template&id=d37cd3f4&scoped=true"
import script from "./goodsList.vue?vue&type=script&lang=js"
export * from "./goodsList.vue?vue&type=script&lang=js"

import "./goodsList.vue?vue&type=style&index=0&id=d37cd3f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d37cd3f4"]])

export default __exports__